// extracted by mini-css-extract-plugin
export var currencyInput = "_j5-1";
export var currencySymbol = "_j5-0";